import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ReactDOM from "react-dom";

import PT from "./pages/PT";
import EN from "./pages/EN";

import "./style/index.css";

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/" exact component={PT} />
      <Route path="/en" exact component={EN} />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
